import React, { useEffect, useState, useRef } from "react";
import "./styles/BottomCartBar.scss";

interface BottomCartBarProps {
  itemsCount: number;
  totalAmount: number;
  onCartClick: () => void;
}

const getItemsText = (count: number): string => {
  if (count % 10 === 1 && count % 100 !== 11) {
    return "товар";
  } else if (
    [2, 3, 4].includes(count % 10) &&
    ![12, 13, 14].includes(count % 100)
  ) {
    return "товара";
  } else {
    return "товаров";
  }
};

export const BottomCartBar: React.FC<BottomCartBarProps> = ({
  itemsCount,
  totalAmount,
  onCartClick,
}) => {
  const prevCountRef = useRef(itemsCount);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (itemsCount === prevCountRef.current) return;
    prevCountRef.current = itemsCount;
    queueMicrotask(() => setAnimate(true));
    const timer = window.setTimeout(() => setAnimate(false), 300);
    return () => window.clearTimeout(timer);
  }, [itemsCount]);

  if (itemsCount === 0) {
    console.log('BottomCartBar: itemsCount is 0, returning null');
    return null;
  }

  const itemsText = getItemsText(itemsCount);

  const activate = () => {
    if (window.Telegram?.WebApp?.HapticFeedback) {
      window.Telegram.WebApp.HapticFeedback.impactOccurred("light");
    }
    onCartClick();
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    activate();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    e.preventDefault();
    e.stopPropagation();
    activate();
  };

  return (
    <div
      className={`bottom-cart-bar ${animate ? "bottom-cart-bar--updated" : ""}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-label={`Перейти в корзину, ${itemsCount} ${itemsText} на сумму ${totalAmount.toLocaleString(
        "ru-RU"
      )} ₽`}
      onKeyDown={handleKeyDown}
    >
      <div className="bottom-cart-bar__content">
        <div className="bottom-cart-bar__info">
          <div className="bottom-cart-bar__text">
            <p className="bottom-cart-bar__title">
              Корзина: {itemsCount} {itemsText}
            </p>
          </div>
        </div>
        <div className="bottom-cart-bar__icon-wrapper">
          <img
            src="/icons/basket.svg"
            alt="Корзина"
            className="bottom-cart-bar__icon"
          />
        </div>
        <h3 className="bottom-cart-bar__total">
          {totalAmount.toLocaleString("ru-RU")} ₽
        </h3>
      </div>
    </div>
  );
};
